let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("4LWHc")).then(() => parcelRequire('3oO6V'));